import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from '@mui/material';
import React from 'react';
import { ISaveUntestedDialogResult } from 'types/dialogs';

interface ISaveUntestedDialogProps {
	onClose: (res: ISaveUntestedDialogResult) => void;
}

const SaveUntestedDialog: React.FC<ISaveUntestedDialogProps> = ({
	onClose
}) => (
	<Dialog
		open
		maxWidth="sm"
		fullWidth
		PaperProps={{ elevation: 0 }}
		onClose={() => onClose({ proceed: false })}
	>
		<DialogTitle>
			{intl.tr('ssoConfig.testPage.saveUntestedDialog.title')}
		</DialogTitle>
		<DialogContent>
			<DialogContentText>
				{intl.tr('ssoConfig.testPage.saveUntestedDialog.message')}
			</DialogContentText>
		</DialogContent>
		<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
			<Button
				variant="outlined"
				onClick={() => onClose({ proceed: false })}
				data-testid="save-untested-cancel-button"
			>
				{intl.tr('ssoConfig.testPage.saveUntestedDialog.cancelButton')}
			</Button>
			<Button
				variant="contained"
				onClick={() => onClose({ proceed: true })}
				data-testid="save-untested-confirm-button"
			>
				{intl.tr('ssoConfig.testPage.saveUntestedDialog.confirmButton')}
			</Button>
		</DialogActions>
	</Dialog>
);

export default SaveUntestedDialog;
